import { render, staticRenderFns } from "./_answerQuestion.vue?vue&type=template&id=2a44a56d"
import script from "./_answerQuestion.vue?vue&type=script&lang=js"
export * from "./_answerQuestion.vue?vue&type=script&lang=js"
import style0 from "./_answerQuestion.vue?vue&type=style&index=0&id=2a44a56d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports